import React, { ReactElement, ReactNode } from 'react';
import NavBars from './navBars';
import { Typography, Tooltip, Menu, Dropdown, Avatar } from 'antd';
import './index.less';
import { ArrowLeftOutlined, EllipsisOutlined } from '@ant-design/icons';
import goto from '@/common/utils/goto';
import classnames from 'classnames';

const { Paragraph } = Typography;

interface avatarType {
  src: string;
}

interface extraInfoType {
  key?: ReactNode;
  value: ReactNode;
}

interface propsType {
  filterCrumbs?: (breadCrumbs: Array<any>) => Array<object>;
  btns?: Array<ReactElement> | ReactElement;
  extraInfo?: Array<extraInfoType>;
  renderCrumbs?: (breadCrumbs: Array<any>) => any;
  backIcon?: ReactNode | boolean;
  onBack?: () => void;
  background?: string;
  tooltip?: ReactNode | string;
  avatar?: avatarType;
  className?: string;
  style?: any;
}

const emptyStyle = {};

export default function DetailHeaderInfoWrapper(props: propsType) {
  const {
    filterCrumbs,
    className,
    btns,
    extraInfo = [],
    avatar,
    renderCrumbs,
    onBack = () => goto.prev(),
    background = '#f5fbff url(//img30.360buyimg.com/pop/jfs/t1/94046/35/20488/11573/61d4310eEea40992d/c19a3c48ba28c35c.png) right bottom/325px no-repeat',
    backIcon = (
      <Tooltip title="返回上一页">
        <ArrowLeftOutlined />
      </Tooltip>
    ),
    style = emptyStyle,
  } = props;

  function BtnsRender() {
    if (Array.isArray(btns)) {
      const btn_3 = btns.slice(0, 3);
      const more_btn = btns.slice(3);
      const menu = more_btn.length ? (
        <Menu>
          {more_btn.map((item: any, index) => {
            return (
              <Menu.Item key={index} {...item.props}>
                {item.props.children}
              </Menu.Item>
            );
          })}
        </Menu>
      ) : null;
      return (
        <div className="activity-detail-header-firstline-btn">
          {React.Children.map(btn_3, (child) => child && React.cloneElement(child, { shape: 'round' }))}
          {menu ? (
            <Dropdown className="more-btns" trigger={['click']} placement="bottomRight" overlay={menu}>
              <EllipsisOutlined />
            </Dropdown>
          ) : null}
        </div>
      );
    }
    return btns ? <div className="activity-detail-header-firstline-btn">{btns}</div> : null;
  }

  return (
    <div
      className={classnames('activity-detail-header', className)}
      style={{ background: background, minWidth: '1200px', ...style }}
    >
      {!!backIcon && (
        <div className="navbar-back-icon" onClick={onBack}>
          {backIcon}
        </div>
      )}
      {!!avatar && (
        <span className="navbar-avatar">
          <Avatar shape="square" size={50} {...avatar} />
        </span>
      )}
      <div className="activity-detail-header-container">
        <div className="activity-detail-header-firstline">
          <div className="activity-detail-header-firstline-title">
            <NavBars filterCrumbs={filterCrumbs} renderCrumbs={renderCrumbs} />
          </div>
          <BtnsRender />
        </div>
        {extraInfo.length ? (
          <div className="activity-detail-header-extra-info">
            {extraInfo.map((item, index) => {
              if (index === extraInfo.length - 1 && typeof item.value == 'string') {
                return (
                  <Tooltip placement="bottom" title={item.value} key={index} overlayStyle={{ maxWidth: 350 }}>
                    <Paragraph className="extra-info-item" ellipsis>
                      {item.key}
                      {item.key && '：'}
                      {item.value}
                    </Paragraph>
                  </Tooltip>
                );
              }
              return (
                <div className="extra-info-item" key={index}>
                  {item.key}
                  {item.key && '：'}
                  {item.value}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
